import React, { Component } from 'react';
import ArrowLeft from '@material-ui/icons/ChevronLeft';
import ArrowRight from '@material-ui/icons/ChevronRight';
import Ellipsis from '@material-ui/icons/MoreHoriz';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
export const createArray = (pages, active) => {
  if (!pages) return [];
  if (pages < 8) {
    return Array(pages).fill().map((page, i) => i + 1);
  } else if (active < 5) {
    return Array(7).fill().map((page, i) => {
      const index = i + 1;
      if (index === 6) {
        return -1;
      } else if (index === 7) {
        return pages;
      } else {
        return index;
      }
    });
  } else if (active > pages - 4) {
    return Array(7).fill().map((page, i) => {
      const index = i + 1;
      if (index === 2) {
        return -1;
      } else if (index === 1) {
        return 1;
      } else {
        const diff = index - 7;
        return pages + diff;
      }
    });
  } else {
    return Array(7).fill().map((page, i) => {
      const index = i + 1;
      if (index === 6 || index === 2) {
        return -1;
      } else if (index === 1) {
        return 1;
      } else if (index === 7) {
        return pages;
      } else {
        const diff = index - 4;
        return active + diff;
      }
    });
  }
};
class DefiPagination extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      active: 1,
      pagination: [1]
    };
  }
  UNSAFE_componentWillMount() {
    this.setPaginationOptions();
    if (this.props.page && this.props.page !== this.state.active) {
      this.setState({
        active: this.props.page
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.active !== this.state.active || this.props.pages !== prevProps.pages) {
      this.setPaginationOptions();
    }
    if (this.props.page !== this.state.active) {
      this.setState({
        active: this.props.page
      });
    }
    if (this.props.pages && this.props.pages !== this.state.pagination[this.state.pagination.length - 1]) {
      this.setState({
        pagination: this.setPaginationOptions('update')
      });
    }
  }
  setPaginationOptions(update) {
    const active = this.state.active;
    const arr = createArray(this.props.pages, active);
    if (update) {
      return arr;
    } else {
      this.setState({
        pagination: arr
      });
    }
  }
  left() {
    const page = this.state.active - 1;
    this.props.changePage({
      page
    });
    this.setState({
      active: page
    });
  }
  right() {
    const page = this.state.active + 1;
    this.props.changePage({
      page
    });
    this.setState({
      active: page
    });
  }
  select(page) {
    this.props.changePage({
      page
    });
    this.setState({
      active: page
    });
  }
  renderList() {
    const _this$state = this.state,
      active = _this$state.active,
      pagination = _this$state.pagination;
    const classes = this.props.classes;
    const list = pagination.map((page, i) => {
      if (page === -1) {
        return /*#__PURE__*/React.createElement(Ellipsis, {
          focusable: "focusable",
          key: i,
          className: "".concat(classes.item, " ").concat(classes.ell)
        });
      }
      return /*#__PURE__*/React.createElement("li", {
        key: i,
        className: active === page ? "".concat(classes.active, " ").concat(classes.item, " ").concat(classes.number, " Page-").concat(page) : "not-active ".concat(classes.item, " ").concat(classes.number, " Page-").concat(page),
        onClick: active !== page ? () => this.select(page) : () => null,
        "data-testid": "page-".concat(page)
      }, page);
    });
    return list;
  }
  renderResults() {
    const records = this.props.records;
    let recordsText = '';
    if (records) {
      recordsText += records;
    } else {
      recordsText += 'No';
    }
    recordsText += ' Result';
    if (records > 1 || records < 1 || records === undefined) {
      recordsText += 's';
    }
    return recordsText;
  }
  render() {
    const active = this.state.active;
    const _this$props = this.props,
      classes = _this$props.classes,
      pages = _this$props.pages,
      records = _this$props.records;
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 10,
      "data-testid": "pagination"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 1,
      sm: 3
    }), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 6
    }, /*#__PURE__*/React.createElement("center", {
      className: classes.center
    }, /*#__PURE__*/React.createElement("ul", {
      className: classes.pagination
    }, active > 1 ? /*#__PURE__*/React.createElement(ArrowLeft, {
      "data-testid": "arrow-left",
      focusable: "focusable",
      className: "".concat(classes.item, " ").concat(classes.arrow),
      onClick: () => this.left()
    }) : /*#__PURE__*/React.createElement("li", {
      className: "".concat(classes.item, " ").concat(classes.blank)
    }), this.renderList(), active < pages && pages > 1 ? /*#__PURE__*/React.createElement(ArrowRight, {
      "data-testid": "arrow-right",
      focusable: "focusable",
      className: "".concat(classes.item, " ").concat(classes.arrow),
      onClick: () => this.right()
    }) : /*#__PURE__*/React.createElement("li", {
      className: "".concat(classes.item, " ").concat(classes.blank)
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4,
      sm: 3
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.results,
      "data-testid": "results"
    }, this.renderResults())));
  }
}
export default withStyles(styles)(DefiPagination);